<template>
  <div>
    <div
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <Vitel v-if="$route.params.provider === 'VITEL_GLOBAL'" />
      <KFMail v-if="$route.params.provider === 'MAIL'" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        companyVitelConfig: {},
        loginUserVitelConfig: {},
        showTextArea: false,
        configurationLoading: false,
        form: {
          extension: '',
          destination: '',
        },
      };
    },
    components: {
      Vitel: () => import('./vitel.vue'),
      KFMail: () => import('./KF-mail/emails.vue'),
    },
    beforeDestroy() {
      this.resetData();
    },
    methods: {
      resetData() {
        this.companyVitelConfig = {};
        this.loginUserVitelConfig = {};
        this.showTextArea = false;
        this.configurationLoading = false;
        this.form = {
          extension: '',
          destination: '',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .error {
    color: red;
  }
</style>
